<template>
  <div class="charge-setting">
    <div class="set-campus-main">
      <el-row type="flex" justify="end" class="tuolele-main-search">
        <el-alert
          title="设置扣费方式转换没有撤销操作，如不想变更，请把变更时间调后，例如：2088年等"
           show-icon
           :closable="false"
          type="warning">
        </el-alert>
        <el-button
          type="primary"
          @click="selectChangeShop"
        >批量设置扣费方式</el-button>
        <el-tooltip placement="right">
          <div slot="content">
            <p class="el-tooltip__popper-text">
              操作提示：
              <br>1、点击“设置”，可针对单个或多个校区，编辑课时的扣费方式
              <br>2、切换课时扣费方式
              <br>&nbsp;&nbsp;&nbsp;1）未设置状态下：系统将默认按当前课时扣费方式，进行扣费
              <br>&nbsp;&nbsp;&nbsp;2）已设置状态下：系统将根据设置日期，自动切换扣费方式
              <br>3、为不影响课时正常扣费，建议可以提前3天进行设置
            </p>
          </div>
          <i class="hove-tit el-icon-question" />
        </el-tooltip>
      </el-row>
      <el-table
        :data="tableData"
        border
        stripe
        :header-cell-style="{
          background: '#4c84ff',
          color: '#fff',
          height: '60px',
          textAlign: 'center'
        }"
        @selection-change="chargeSelectionChange"
      >
        <el-table-column
          type="selection"
          align="center"
          width="200px"
        />
        <el-table-column
          align="center"
          prop="name"
          label="校区名称"
        />
        <el-table-column align="center" label="当前课时扣费方式">
          <template slot-scope="scope">
            <span
              v-text="
                scope.row.config.configuration_value == 'TIME_HOLIDAY'
                  ? '假期'
                  : '常规'
              "
            />
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="change_time"
          label="下次切换时间"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.config.change_status==1">{{
              scope.row.config.change_time
            }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="changeType"
          label="切换课时扣费方式"
        >
          <template slot-scope="scope">
            <span>{{
              scope.row.config.change_status
                | changeStatus(
                  scope.row.config.change_timestamp,
                  scope.row.config.configuration_value
                )
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          align="center"
          prop="editor_name"
          label="操作人" 
        >
          <template slot-scope="scope" v-if="scope.row.config.editor_name">
            <span>{{
              scope.row.config.editor_name
            }}<br>（ {{scope.row.config.create_time}}）</span>
          </template>
        </el-table-column>
        
      </el-table>
    </div>
    <el-dialog title="设置扣费方式变更时间" :visible.sync="dialogVisible">
      <div class="dialog-content">
        <span>变更时间</span>
        <el-date-picker
          v-model="date_day"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        />
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmChangeDate">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ChargeCharge',
  filters: {
    changeStatus(status, date, type) {
      const nowDate = new Date().getTime()
      if (status == '0') {
        return '未设置'
      } else {
        date = date * 1000
        if (date > nowDate) {
          const time = new Date(date)
          const day =
            time.getFullYear() +
            '-' +
            (time.getMonth() + 1) +
            '-' +
            time.getDate()
          if (type == 'TIME_HOLIDAY') {
            return day + ',将按常规方式扣费'
          } else {
            return day + ',将按假期方式扣费'
          }
        } else {
          return '扣费方式已切换'
        }
      }
    }
  },
  data() {
    return {
      tableData: [],
      date_day: '',
      shop_id: [],
      dialogVisible: false
    }
  },
  mounted() {
    this.changeDeductionMethod()
  },
  methods: {
    chargeSelectionChange(val) {
      this.shop_id = []
      this.shop_id = val.map(e => {
        return e.id
      })
    },
    selectChangeShop() {
      if (this.shop_id.length != 0) {
        this.dialogVisible = true
      }
    },
    confirmChangeDate() {
      if (this.date_day) {
        const params = {
          shop_id: this.shop_id.join(','),
          date_day: this.date_day
        }
        this.$http.changeDeductionMethodSubmit(params).then(res => {
          if (res.code == 200) {
            this.dialogVisible = false
            this.date_day = ''
            this.changeDeductionMethod()
          }
        })
      }
    },
    changeDeductionMethod() {
      this.$http.changeDeductionMethod().then(res => {
      // console.log(res.data)
        this.tableData = res.data
      })
    }
  }
}
</script>

<style lang="scss">
.charge-setting {
  .set-campus-main {
    width: 100%;
    height: 100%;
    background-color: #ffffff;
    box-shadow: 0px 6px 20px 0px rgba(210, 210, 210, 0.5);
    border-radius: 10px;
    padding: 40px;
    margin-bottom: 80px;
    .main-btn {
      margin-bottom: 40px;
    }
  }
  .el-dialog {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 620px;
    margin-top: 0 !important;
    .dialog-content span {
      margin-right: 20px;
    }
    .el-dialog__title {
      color: $color_blue;
    }
  }
}
.el-table--border td,
.el-table--border th,
.el-table__body-wrapper .el-table--border.is-scrolling-left ~ .el-table__fixed {
  border: none !important;
}
</style>
